import React from "react";
import CurrencyGenericSkeleton from "./CurrencyGenericSkeleton";

function CurrencyDetailSkeleton() {
  return (
    <>
      <CurrencyGenericSkeleton />
    </>
  );
}

export default CurrencyDetailSkeleton;
